import { Group, Text } from '@mantine/core';
import { palette } from '../../colors';
import { IconSparkles } from '@tabler/icons-react';

function AIBadge(props: { size?: 'sm' | 'md' } = { size: 'md' }) {
  const size = props.size === 'sm' ? 12 : 14;
  const fontSize = props.size === 'sm' ? 'xs' : 'sm';
  const padding = props.size === 'sm' ? '0.1rem 0.25rem' : '0.1rem 0.4rem';

  return (
    <Group
      variant="light"
      bg={palette.blackroomAI}
      gap="0.2rem"
      style={{ borderRadius: '0.4rem', padding: padding }}
    >
      <IconSparkles size={size} color={palette.blackroomWhite} />
      <Text c={palette.blackroomWhite} size={fontSize}>
        AI
      </Text>
    </Group>
  );
}

export default AIBadge;
